const GasIcon = () => {
  return (
    <span className="w-[42px] h-[42px] rounded-full block bg-gradient-to-tr from-[#0259ab] to-[#19d5ff] via-[#0495fa] mr-3">
      <svg xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#FFF"
          d="M20.916 31.279c-2.029 0-3.674-1.78-3.674-3.973 0-3.11 3.674-6.527 3.674-6.527s3.676 3.416 3.676 6.527c0 2.193-1.647 3.973-3.676 3.973m.001-23.1s-9.45 8.2-9.45 15.668c0 5.263 4.23 9.532 9.45 9.532 5.22 0 9.45-4.27 9.45-9.532 0-7.468-9.45-15.668-9.45-15.668"
        />
      </svg>
    </span>
  );
};

export default GasIcon;
